// This file will be deleted after migration to Compass Avatar.
const roundedMd = "rounded-md"; // on new tokens, this is now 8px

export const boxSizes = {
  "5": "w-5 h-5",
  "6": "w-6 h-6",
  "7": "w-7 h-7",
  "8": "w-8 h-8",
  "9": "w-9 h-9",
  "10": "w-10 h-10",
  "14": "w-14 h-14",
  "16": "w-16 h-16",
  "24": "w-24 h-24",
} as const;

export const textSizes = {
  "5": "text-xs", // was text-xxs → text-xs
  "6": "text-xs",
  "7": "text-xs",
  "8": "text-sm",
  "9": "text-md", // was text-base → text-md
  "10": "text-md", // was text-base → text-md
  "14": "text-md", // was text-base → text-md
  "16": "text-lg", // was text-xl → text-lg
  "24": "text-2xl", // was text-4xl → text-2xl
} as const;

export const borderRadiusSizes = {
  "5": "rounded-[3px]", // was rounded-3px → arbitrary value (safe)
  "6": "rounded-[4px]", // was rounded-4px → arbitrary value (safe)
  "7": "rounded-[4px]", // was rounded-4px → arbitrary value (safe)
  "8": "rounded-[5px]", // was rounded-5px → arbitrary value (safe)
  "9": roundedMd,
  "10": roundedMd,
  "14": roundedMd,
  "16": roundedMd,
  "24": "rounded-lg", // was rounded-xl → rounded-lg (semantic mapping)
} as const;

export const borderRadiusWithBorderSizes = {
  "5": "rounded-[5px]", // was rounded-5px → arbitrary value (safe)
  "6": roundedMd,
  "7": roundedMd,
  "8": "rounded-[7px]", // was rounded-7px → arbitrary value (safe)
  "9": roundedMd,
  "10": roundedMd,
  "14": "rounded-[10px]", // was rounded-10px → arbitrary value (safe)
  "16": "rounded-[10px]", // was rounded-10px → arbitrary value (safe)
  "24": "rounded-[14px]", // was rounded-14px → arbitrary value (safe)
} as const;

export type UserImageSizes = keyof typeof boxSizes;
